import system from './system';
import Index from '@/view/Index';
import Login from '@/view/Login';
import Coupon from '@/view/Coupon';
import CouponError from '@/view/CouponError';
import Staff from '@/view/Staff';
import StaffQrcode from '@/view/StaffQrcode';
import Customer from '@/view/Customer';
import CustomerCoupon from '@/view/CustomerCoupon';
import CustomerError from '@/view/CustomerError';
import TransferLd from '@/view/TransferLd';
import transferMerber from '@/view/TransferMerber';
import TransferMall from '@/view/TransferMall';
import OpenWeapp from '@/view/OpenWeapp';
import BaseExport from '@/view/myBaseExport';
import Error404 from '@/view/Error404';
import WsProtocol from '@/view/WsProtocol';
import WsProtocolNc from '@/view/WsProtocolNc';
import WsProtocolTp from '@/view/WsProtocolTp';
import TransferInvoice from '@/view/TransferInvoice';

export default [
  ...system,
  {
    path: '/index',
    element: Index,
    meta: {
      title: '我是首页',
      isHeader: true, //是否展示顶部header
      optional: ['id'], //可选参数
      hideMenu: false, //是否隐藏微信里面右上角菜单
    },
  },
  {
    path: '/login',
    element: Login,
    meta: {
      title: '',
      isHeader: true, //是否展示顶部header
      optional: ['id'],
      hideMenu: false, //是否隐藏微信里面右上角菜单
    },
  },
  {
    path: '/coupon/:id/:uid',
    element: Coupon,
    meta: {
      title: '',
      isHeader: true, //是否展示顶部header
      // optional: ['id'],
    },
  },
  {
    path: '/couponError',
    element: CouponError,
    meta: {
      title: '',
      isHeader: false, //是否展示顶部header
      optional: ['id'],
    },
  },
  {
    path: '/staff/:activityId',
    element: Staff,
    meta: {
      title: '员工扫码',
      isHeader: true, //是否展示顶部header
      hideMenu: true,
    },
  },
  {
    path: '/staffQrcode/:activityId',
    element: StaffQrcode,
    meta: {
      title: '员工扫码二维码',
      isHeader: true, //是否展示顶部header
      hideMenu: true, //是否隐藏微信里面右上角菜单
    },
  },
  {
    path: '/staffQrcode/:activityId/:staffId',
    element: StaffQrcode,
    meta: {
      title: '员工扫码二维码',
      isHeader: true, //是否展示顶部header
      hideMenu: true, //是否隐藏微信里面右上角菜单
    },
  },
  {
    path: '/customer/:id/:staffId',
    element: Customer,
    meta: {
      title: '',
      isHeader: true, //是否展示顶部header
      optional: [],
      hideMenu: true, //是否隐藏微信里面右上角菜单
    },
  },
  {
    path: '/customerCoupon/:id/:uid',
    element: CustomerCoupon,
    meta: {
      title: '',
      isHeader: true, //是否展示顶部header
      hideMenu: true, //是否隐藏微信里面右上角菜单
    },
  },
  {
    path: '/customerError/:id',
    element: CustomerError,
    meta: {
      title: '',
      isHeader: false, //是否展示顶部header
      optional: [],
      hideMenu: true, //是否隐藏微信里面右上角菜单
    },
  },
  {
    path: '/transferLd',
    element: TransferLd,
    meta: {
      isHeader: false, //是否展示顶部header
    },
  },
  {
    path: '/transferMerber',
    element: transferMerber,
    meta: {
      isHeader: false, //是否展示顶部header
    },
  },
  {
    path: '/mall',
    element: TransferMall,
    meta: {
      isHeader: false, //是否展示顶部header
    },
  },
  {
    path: '/openWeapp/:id',
    element: OpenWeapp,
    meta: {
      title: '跳转小程序',
      isHeader: false, //是否展示顶部header
    },
  },
  {
    path: '/baseExport/:source/:userId',
    element: BaseExport,
    meta: {
      title: '',
      isHeader: true, //是否展示顶部header
    },
  },
  {
    path: '/error404',
    element: Error404,
    meta: {
      isHeader: false, //是否展示顶部header
    },
  },
  {
    path: '/wsProtocol/:type',
    element: WsProtocol,
    meta: {
      isHeader: true, //是否展示顶部header
    },
  },
  {
    path: '/wsProtocolNc/:type',
    element: WsProtocolNc,
    meta: {
      isHeader: true, //是否展示顶部header
    },
  },
  {
    path: '/wsProtocolTps/:type',
    element: WsProtocolTp,
    meta: {
      isHeader: true, //是否展示顶部header
    },
  },
  {
    path: '/transferInvoice',
    element: TransferInvoice,
    meta: {
      isHeader: false, //是否展示顶部header
    },
  },
];
